module.exports = __webpack_public_path__ + "img/hot-air-balloon.8809f926.svg";